import {
  getActiveImpersonation,
  updateTimezoneQuietly,
} from '../services/auth';
import type { User } from '../types/User';
import { getUserIANA } from './getUserIANA';

// OAuth signups do not capture a timezone, leaving users on America/Los_Angeles
// and mis-targeted as US by timezone-based email filters. Backfill it on app load.
export const syncUserTimezone = async (user: User): Promise<void> => {
  try {
    if (user.isAnon || getActiveImpersonation()) {
      return;
    }

    const deviceTimezone = getUserIANA();
    const throttleKey = `ora-timezone-synced:${user.id}`;
    if (
      !deviceTimezone ||
      deviceTimezone === user.timezone ||
      sessionStorage.getItem(throttleKey) === deviceTimezone
    ) {
      return;
    }

    sessionStorage.setItem(throttleKey, deviceTimezone);
    await updateTimezoneQuietly(deviceTimezone);
  } catch {
    // Timezone sync is best-effort, including in restricted storage contexts.
  }
};
